import React from "react";
// import ReactApexChart from "react-apexcharts";

class ApexChart extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      series: [
        {
          name: this.props.title ? this.props.title: "",
          data: this.props.data ? this.props.data: [],
        },
      ],
      options: {
        chart: {
          id: "area-datetime",
          type: "area",
        },
        annotations: {
          yaxis: [],
          xaxis: [],
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          width: 3
        },
        markers: {
          size: 0,
          style: "hollow",
        },
        xaxis: {
          type: "datetime",
          tickAmount: 6,
        },
        tooltip: {
          x: {
            format: "dd MMM yyyy",
          },
        },
        fill: {
          type: "gradient",
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.7,
            opacityTo: 0.9,
            stops: [0, 100],
          },
        },
      },
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.props !== nextProps) {
      this.setState({
        series: [{ data: this.props.data ? this.props.data: [] }],
      });
    }
  }

  render() {
    return (
      <div id="chart">
        <div id="chart-timeline">
          {/* <ReactApexChart
            options={this.state.options}
            series={this.state.series}
            type="area"
            height={350} /> */}
          
        </div>
      </div>
    );
  }
}

export default ApexChart;
